
<router-outlet></router-outlet>
<div class="outerWrapper">
    <app-header *ngIf="router.url!='/Login' && router.url!='/Error' "></app-header>
    <app-sidebar *ngIf="router.url!='/Login' && router.url!='/Error' && router.url!='/Task'"></app-sidebar>
    <div class="content contentWrapper" *ngIf="router.url=='/Login'">      
        <router-outlet></router-outlet>
    </div>
    <div class="contentError" *ngIf="router.url=='/Error'">      
        <router-outlet></router-outlet>
    </div>
    <div class="content" *ngIf="router.url!='/Login' && router.url!='/Error'">      
        <router-outlet></router-outlet>
    </div>
    <app-footer *ngIf="router.url!='/Login' && router.url!='/Error'"></app-footer>
</div>
